import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/** Latest change first by default, like the old leave list's default `{ LastUpdateDate: -1 }` sort. */
export const DEFAULT_MY_LEAVE_REQUESTS_ORDER: OrderBy[] = [
  { field: 'LastUpdatedDate', direction: 'DESC' },
];

export const buildGetLeaveRequestsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_MY_LEAVE_REQUESTS_ORDER
) => `
  query {
    LeaveRequests: getLeaveRequests(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        Title
        UserId
        DisplayName
        DepartmentName
        LeaveCategoryId
        LeaveCategory
        LeaveType
        StartDate
        EndDate
        Reason
        Status
        IsArchived
        Note
        Timezone
        FileIds
        IsDocumentSendByDr
      }
    }
  }
`;

/** The employee's current HR term with its leave categories: what they can request leave of. */
export const buildGetMyCurrentLeaveAllotmentsQuery = (where: Record<string, unknown>) => `
  query {
    HrProfiles: getUserHRPeriodicalProfiles(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(1, 1)}
    ) {
      items {
        ItemId
        EmploymentType
        LeaveAllotments {
          LeaveCategoryId
          LeaveCategory
          IsApplicable
          IsDefault
          IsUnlimited
          LeaveLimitTotalDays
        }
      }
    }
  }
`;

// Note: LeaveCategory's query field is "LeaveCategorys" (schema name + literal
// "s", not smart pluralization) — see SCHEMA_REFERENCE.json.
export const buildGetLeaveCategoriesLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    LeaveCategorys: getLeaveCategorys(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
      }
    }
  }
`;
